import { typedFetch } from "@/lib/helpers";
import { API_METHODS } from "../shared";
import { CREATE_ROOM_URL } from "./api-url.constants";
import { CreateRoomDto, CreateRoomResonse } from "./dtos/create-room.api.dto";
import { CreateRoomError } from "./errors/create-room-error.errors";
import { CreateRoomErpIntegrationsError } from "./errors/create-room-erp-integrations-error.errors";
import { CREATE_ROOM_ERP_INTEGRATIONS_ERROR_MESSAGE } from "./errors/error-message.constants";

export const createRoom = async (createRoomDto: CreateRoomDto): Promise<string> => {
  const result = await typedFetch(CREATE_ROOM_URL, {
    method: API_METHODS.POST,
    body: JSON.stringify(createRoomDto),
  });

  const responseJson = await result.json();

  if (result.ok) {
    const response = responseJson as { data: CreateRoomResonse };
    return response.data.roomId;
  }

  if ("error" in responseJson) {
    const message = Array.isArray(responseJson.message)
      ? responseJson.message[0]
      : responseJson.message;
    if (message === CREATE_ROOM_ERP_INTEGRATIONS_ERROR_MESSAGE)
      throw new CreateRoomErpIntegrationsError();
    throw new CreateRoomError();
  }

  return "";
};
